import React, { useEffect, useState } from "react";
import adminApi from "../../services/adminApi";
import toast from "react-hot-toast";
import VisibilityForm from "./VisibilityForm";
import VisibilityTable from "./VisibilityTable";
import LoadingState from "../../components/Admin/LoadingState";
import ConfirmModal from "../../components/common/ConfirmModal";
import "../../styles/Admin.css";

export default function VisibilitySettings() {
  const [rules, setRules] = useState(null);
  const [form, setForm] = useState({ type: "", identifier: "", disabled: true });
  const [saving, setSaving] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);

  const load = () => {
    adminApi
      .get("/admin/settings/visibility")
      .then((res) => setRules(res.data))
      .catch(() => toast.error("Failed to load visibility rules"));
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    if (!form.identifier.trim()) {
      toast.error("Identifier is required");
      return;
    }
    setSaving(true);
    try {
      await adminApi.put("/admin/settings/visibility", form);
      toast.success(`Resource "${form.identifier}" is now disabled for users`);
      setForm({ type: "", identifier: "", disabled: true });
      load();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save rule");
    } finally {
      setSaving(false);
    }
  };

  const handleEnable = async (rule) => {
    setDeleteModal(rule);
  };

  const confirmEnable = async () => {
    if (!deleteModal) return;
    try {
      await adminApi.put("/admin/settings/visibility", {
        type: deleteModal.type,
        identifier: deleteModal.identifier,
        disabled: false, // Enable the resource
      });
      toast.success(`${deleteModal.type} "${deleteModal.identifier}" is now enabled for users`);
      setDeleteModal(null);
      load();
    } catch (error) {
      toast.error("Failed to enable resource");
    }
  };

  if (rules === null) {
    return <LoadingState message="Loading visibility rules..." />;
  }

  return (
    <>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Visibility Rules</h1>
        <p className="admin-page-subtitle">Control which OS, Applications, and Regions are available to users</p>
      </div>

      <VisibilityForm form={form} onChange={setForm} onSubmit={save} loading={saving} />

      <VisibilityTable
        rules={rules}
        onEnable={handleEnable}
        loading={false}
      />

      <ConfirmModal
        show={!!deleteModal}
        title="Enable Resource"
        message={`Are you sure you want to enable ${deleteModal?.type} "${deleteModal?.identifier}"? This will make it available to users again.`}
        confirmText="Enable"
        cancelText="Cancel"
        variant="primary"
        onConfirm={confirmEnable}
        onClose={() => setDeleteModal(null)}
      />
    </>
  );
}


